<template>
    <e-dropdown class="is-modal-sorts" aria-role="list" @input="applySort">
        <template #trigger>
            <e-button type="is-primary" icon-right="sort" @click.prevent>Sorts</e-button>
        </template>

        <e-dropdown-item
            v-for="sortField in sorts"
            :key="sortField"
            :model-value="sortField"
            :focusable="false"
            icon="sort"
        >
            <div class="tw:flex tw:gap-2 tw:items-center">
                <p>{{ capitalCase(sortField) }}</p>

                <div>
                    <e-icon v-if="sortField === sort && order === 'asc'" icon="arrow-up" />
                    <e-icon v-else-if="sortField === sort && order === 'desc'" icon="arrow-down" />
                    <e-icon v-else icon="sort" />
                </div>
            </div>
        </e-dropdown-item>
    </e-dropdown>
</template>

<script>
import { capitalCase } from 'change-case';

export default {
    name: 'ModalSorts',

    props: {
        sorts: {
            type: Array,
            required: true,
        },
        currentSort: {
            type: String,
            default: null,
        },
        currentOrder: {
            type: String,
            default: 'asc',
        },
    },

    emits: ['apply-sort'],

    data: () => ({
        sort: null,
        order: 'asc',
    }),

    watch: {
        currentSort: {
            immediate: true,
            handler(newVal) {
                this.sort = newVal;
            },
        },
        currentOrder: {
            immediate: true,
            handler(newVal) {
                this.order = newVal;
            },
        },
    },

    created() {},

    methods: {
        capitalCase,

        applySort(sort) {
            if (this.sort === sort) {
                this.order = this.order === 'asc' ? 'desc' : 'asc';
            } else {
                this.order = 'asc';
            }

            this.sort = sort;
            this.$emit('apply-sort', sort, this.order);
        },
    },
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.is-modal-sorts {
    .dropdown-item {
        padding-right: 1rem;
    }
}
</style>
